import React from 'react';
import {
  CalendarWrapper,
  CalendarHeader,
  PrevArrow,
  MonthYearSelectorWrapper,
  HeaderDropdown,
  NextArrow,
  CalendarGrid,
  Day
} from './styles/DateCalendar.styles';

const DateCalendarControl = ({ control }) => {
  const targetDate = control.showNow ? new Date() : new Date(control.specificDate || Date.now());

  const year = targetDate.getFullYear();
  const month = targetDate.getMonth(); // 0-11
  const day = targetDate.getDate();

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const daysOfWeek = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

  const firstDayOfMonth = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const paddingDays = Array.from({ length: firstDayOfMonth }, () => null);
  const dayCells = Array.from({ length: daysInMonth }, (_, i) => i + 1);
  const calendarGrid = [...paddingDays, ...dayCells];

  return (
    <CalendarWrapper styleProps={control.attributes}>
      <CalendarHeader styleProps={control.attributes}>
        <PrevArrow>Prev</PrevArrow>
        <MonthYearSelectorWrapper>
          <HeaderDropdown>{monthNames[month]}</HeaderDropdown>
          <HeaderDropdown>{year}</HeaderDropdown>
        </MonthYearSelectorWrapper>
        <NextArrow>Next</NextArrow>
      </CalendarHeader>
      <CalendarGrid>
        {daysOfWeek.map((day, i) => <Day key={`h-${i}`} isHeader>{day}</Day>)}
        {calendarGrid.map((d, i) => (
          <Day styleProps={control.attributes} key={`d-${i}`} isSelected={d === day}>
            {d}
          </Day>
        ))}
      </CalendarGrid>
    </CalendarWrapper>
  );
};

export default DateCalendarControl;